<div class="d-flex flex-column pt-medium">
  <div
    id="assets"
    class="px-atom"
  >
    <common-user-assets-assets-slider></common-user-assets-assets-slider>
  </div>

  <div class="px-plus search-container">
    <common-ui-components-search
      [readOnlyMode]="true"
      [placeHolder]="'جستجو در فروشگاه‌ها'"
      (clicked)="goToSearch($event)"
    ></common-ui-components-search>
  </div>

  <div class="stores-tabs">
    <ngx-segmented-control
      [options]="tabOptions"
      [selectedOption]="selectedTab()"
      (change)="changeStoresMode($event)"
    >
    </ngx-segmented-control>
    <div class="pt-pony">
      @if (mode() === 'online') {
        <stores-applet-online-stores [bannersData]="bannersData()"></stores-applet-online-stores>
      } @else if (mode() === 'onsite') {
        @defer (when canLoadOnSiteStores()) {
          <stores-applet-onsite-stores [bannersData]="bannersData()"></stores-applet-onsite-stores>
        }
      }
    </div>
  </div>
</div>
